/* eslint-disable @typescript-eslint/ban-types */
import { TextFieldProps } from '@mui/material';
import React, { ForwardedRef, ReactNode, useState } from 'react';
import { Control, Controller, Path, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  validateFormNumberInput,
  validateNotWhitespaceOnly,
} from 'src/utils/formUtils';

import PhoneInput from '../PhoneInput/PhoneInput';

interface FormPhoneInputProps<T> {
  name: Path<T>;
  control: Control<T, object>;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  rules?: RegisterOptions;
  endAdornment?: ReactNode;
  helperText?: string;
  error?: boolean;
  required?: boolean;
  inputProps?: TextFieldProps;
  size?: 'small' | 'medium';
  isMobile?: boolean;
  selectRef?: ForwardedRef<HTMLSelectElement>;
}

export const FormPhoneInput = <T,>({
  name,
  control,
  label,
  placeholder,
  disabled = false,
  className,
  rules,
  endAdornment,
  helperText,
  error = false,
  required = false,
  inputProps,
  size,
  isMobile,
  selectRef,
}: FormPhoneInputProps<T>): JSX.Element => {
  const { t } = useTranslation();
  const [phoneHelperText, setPhoneHelperText] = useState('');
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        ...rules,
        validate: {
          ...rules?.validate,
          ...(rules?.required
            ? {
                whitespaces: validateNotWhitespaceOnly,
                phoneInput: validateFormNumberInput,
              }
            : {}),
        },
      }}
      render={({ field, fieldState }) => (
        <PhoneInput
          inputProps={inputProps}
          selectRef={selectRef}
          value={field.value?.toString() || ''}
          onChange={field.onChange}
          onFocus={() =>
            isMobile && setPhoneHelperText(t('common:mobile_helper_text'))
          }
          onBlur={() => isMobile && setPhoneHelperText('')}
          label={label}
          size={size}
          placeholder={placeholder}
          disabled={disabled}
          className={className}
          error={error || !!fieldState?.error?.message}
          required={required}
          helperText={
            phoneHelperText || helperText || fieldState?.error?.message
          }
        />
      )}
    />
  );
};
